var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovEasyNavigation = function SvgCovEasyNavigation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78.788,
    height: 106.8,
    viewBox: "0 0 78.788 106.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450.743 -97.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.532,204.174H450.743V97.374h60.766l18.022,18.037v6.209h-1.8v-5.464L510.763,99.174h-58.22v103.2h75.188v-73.79h1.8Z",
    transform: "translate(0 0)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,116.683H496.142v-1.8h12.685L494.4,100.448v10h-1.8V98.274a.9.9,0,0,1,1.537-.636l17.5,17.509a.9.9,0,0,1-.637,1.536Z",
    transform: "translate(17.633 0)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.942,114.089H492.6V103.534h1.8v8.755h3.539Z",
    transform: "translate(17.633 2.595)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H52.35V21H-.9ZM50.55.9H.9V19.2H50.55Z",
    transform: "translate(464.413 123.889)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.346,1.125-.9.9-.9-.9l53.25.229Z",
    transform: "translate(464.413 154.487)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,2.562H-.9V-.9H.9Z",
    transform: "translate(464.413 156.56)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,4.413H-.9V-.9H.9Z",
    transform: "translate(515.863 154.709)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,3.3H-.9V-.9H.9Z",
    transform: "translate(490.138 155.824)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,3.362H-.9V-.9H.9Z",
    transform: "translate(490.138 145.412)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,8.54H-.9V-.9H.9Z",
    transform: "translate(490.138 175.318)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,8.54H-.9V-.9H.9Z",
    transform: "translate(515.863 175.318)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H11.177V11.177H-.9ZM9.377.9H.9V9.377H9.377Z",
    transform: "translate(459.274 165.041)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.252,169.031a6.038,6.038,0,1,1,6.038-6.038A6.045,6.045,0,0,1,480.252,169.031Zm0-10.277a4.238,4.238,0,1,0,4.238,4.239A4.244,4.244,0,0,0,480.252,158.754Z",
    transform: "translate(9.886 25.097)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.615-.9H6.661a4.52,4.52,0,0,1,4.515,4.515V6.661a4.52,4.52,0,0,1-4.515,4.515H3.615A4.52,4.52,0,0,1-.9,6.661V3.615A4.52,4.52,0,0,1,3.615-.9ZM6.661,9.376A2.718,2.718,0,0,0,9.376,6.661V3.615A2.718,2.718,0,0,0,6.661.9H3.615A2.718,2.718,0,0,0,.9,3.615V6.661A2.718,2.718,0,0,0,3.615,9.376Z",
    transform: "translate(510.724 182.951)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H36.9V11.19H-.9ZM35.1.9H.9V9.39H35.1Z",
    transform: "translate(484.999 165.034)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.072.9H-.9V-.9H9.072Z",
    transform: "translate(469.789 170.179)",
    fill: "#5680e9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovEasyNavigation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-easy-navigation.a09199b2.svg";
export { ForwardRef as ReactComponent };